<template>
  <page>
    <div :load="doInit">
      <v-expansion-panels  v-model="panel1" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div>
              <v-icon>mdi-calendar-range</v-icon> Date Range
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <v-form>
                  <v-container fluid grid-list-sm>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <cal-picker v-model="reportForm.expiryDateFrom" :label="labels.expiryDateFrom" v-validate="'required'" :data-vv-as="labels.expiryDateFrom" data-vv-name="expiryDateFrom" :error-messages="errors.collect('expiryDateFrom')" :min="fromDateMinDate"></cal-picker>
                      </v-flex>
                      <v-flex xs6>
                        <cal-picker v-model="reportForm.expiryDateTo" :label="labels.expiryDateTo" v-validate="'required'" :data-vv-as="labels.expiryDateTo" data-vv-name="expiryDateTo" :error-messages="errors.collect('expiryDateTo')" :min="reportForm.tranFromData"></cal-picker>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
      <v-expansion-panels v-model="panel2" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div>
              <v-icon>mdi-filter-variant</v-icon> Selection Criteria
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                  <v-container fluid grid-list-sm>
                    <v-layout row wrap>
                      <!-- Billing Account No. From -->
                      <v-flex xs12 sm6 md6 lg6>
                        <v-autocomplete :items="billAcctNoList" v-model="reportForm.acctFrm" :label="labels.acctFrm" item-text="label" item-value="value"
                        data-vv-name="acctFrm" :data-vv-as="labels.acctFrm" :error-messages="errors.collect('acctFrm')"
                        @change="doAcctNoFr" clearable></v-autocomplete>
                      </v-flex>
                      <!-- Billing Account No. To -->
                      <v-flex xs12 sm6 md6 lg6>
                        <v-autocomplete :items="billAcctNoList" v-model="reportForm.acctTo" :label="labels.acctTo" item-text="label" item-value="value"
                        data-vv-name="acctTo" :data-vv-as="labels.acctTo" :error-messages="errors.collect('acctTo')"
                        clearable></v-autocomplete>
                      </v-flex>
                      <!-- Print Cover Letter -->
                      <v-flex xs12 sm6 md6 lg6>
                        <v-autocomplete :items="prntCvrLttrList" v-model="reportForm.prntCvrLttr" :label="labels.prntCvrLttr" item-text="label" item-value="value"
                        data-vv-name="prntCvrLttr" :data-vv-as="labels.prntCvrLttr" :error-messages="errors.collect('prntCvrLttr')"></v-autocomplete>
                      </v-flex>
                      <!-- Policy Type -->
                      <v-flex xs12 sm12 md12 lg12>
                        <v-text-field v-model="reportForm.polType" :label="labels.polType" :error-messages="errors.collect('polType')"
                        :data-vv-as="labels.polType" data-vv-name="polType" append-icon="mdi-magnify" @click:append="multiPolTypeList = true" readonly
                        v-validate="'required'"></v-text-field>
                      </v-flex>
                      <!-- Scheme -->
                      <v-flex xs12 sm12 md12 lg12>
                        <v-text-field readonly v-model="reportForm.scheme" :label="labels.scheme" :error-messages="errors.collect('scheme')"
                        :data-vv-as="labels.scheme" data-vv-name="scheme" append-icon="mdi-magnify" @click:append="multiSchemeList = true"></v-text-field>
                      </v-flex>
                      <!-- BusCls -->
                      <v-flex xs12 sm12 md12 lg12>
                        <v-text-field readonly v-model="reportForm.busCls" :label="labels.busCls" :error-messages="errors.collect('busCls')"
                        :data-vv-as="labels.busCls" data-vv-name="busCls" append-icon="mdi-magnify" @click:append="multiBusClsList = true" clearable></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
      <v-expansion-panels v-model="panel3" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div>
              <v-icon>mdi-filter-variant</v-icon> Applicable for UPP HDB Only
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                  <v-container fluid grid-list-sm>
                    <v-layout row wrap>
                      <!-- Premium Rating -->
                      <v-flex xs12 sm6 md6 lg6>
                        <v-text-field v-model="reportForm.premRt" :label="labels.premRt" :error-messages="errors.collect('premRt')"
                        :data-vv-as="labels.premRt" data-vv-name="premRt" :disabled="isNotUPPHDB"
                        type="number"
                        @blur="decFormat('premRt')"
                        v-validate="'mask_decimal:6|mask_min_value:0'"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md6 lg6> </v-flex>
                      <!-- Minimum Premium -->
                      <v-flex xs12 sm6 md6 lg6>
                        <v-text-field v-model="reportForm.minPrem" :label="labels.minPrem" :error-messages="errors.collect('minPrem')"
                        :data-vv-as="labels.minPrem" data-vv-name="minPrem" :disabled="isNotUPPHDB"
                        type="number"
                        @blur="decFormat('minPrem')"
                        v-validate="'mask_decimal:2|mask_min_value:0'"></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md6 lg6> </v-flex>
                      <!-- Public Liability Premium -->
                      <v-flex xs12 sm6 md6 lg6>
                        <v-text-field v-model="reportForm.pubLbltyPrem" :label="labels.pubLbltyPrem" :error-messages="errors.collect('pubLbltyPrem')"
                        :data-vv-as="labels.pubLbltyPrem" data-vv-name="pubLbltyPrem" :disabled="isNotUPPHDB"
                        type="number"
                        @blur="decFormat('pubLbltyPrem')"
                        v-validate="'mask_decimal:2|mask_min_value:0'"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
      <v-form>
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <v-flex xs12 sm12 md12 lg12>
              <v-checkbox dense v-model="reportForm.printRptRunTime" :label="labels.printRptRunTime" data-vv-name="printRptRunTime" :data-vv-as="labels.printRptRunTime"></v-checkbox>
            </v-flex>
            <v-flex lg6 xs12>
            <v-btn class="mr-2" color="primary" type="submit" :loading="loading" @click.prevent="doExport">
              <v-icon left dark>mdi-file-export</v-icon>
              {{labels.export}}
            </v-btn>
            <v-btn-toggle dense mandatory v-model="reportForm.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{format.label}}</span>
                <v-icon :color="format.color">{{format.icon}}</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </div>
      <v-dialog v-model="multiPolTypeList" width="900px" persistent>
        <multi-pol-type-help-list :pt="reportForm.polType" @close="doClose" @doAssign="doAssignPolType($event)"></multi-pol-type-help-list>
      </v-dialog>
      <v-dialog v-model="multiSchemeList" width="900px" persistent>
        <multi-scheme-help-list :scheme="reportForm.scheme" @close="doClose" @doAssign="doAssignScheme($event)"></multi-scheme-help-list>
      </v-dialog>
      <v-dialog v-model="multiBusClsList" width="900px" persistent>
        <multi-bus-cls-help-list :busCls="reportForm.busCls" @close="doClose" @doAssign="doAssignBusCls($event)"></multi-bus-cls-help-list>
      </v-dialog>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { checkDateRangeFrom, checkDateRangeTo } from '@/directives/common'
import MultiPolTypeHelpList from '@/components/core/common/dialog/MultiPolTypeHelpList'
import MultiSchemeHelpList from '@/components/core/common/dialog/MultiSchemeHelpList.vue'
import MultiBusClsHelpList from '@/components/core/common/dialog/MultiBusClsHelpList.vue'

export default {
  data() {
    return {
      labels: {
        dateRange: 'Date Ranges',
        expiryDateFrom: 'Expiry Date From*',
        expiryDateTo: 'Expiry Date To*',
        acctFrm: 'Billing Account From',
        acctTo: 'Billing Account To',
        polType: 'Policy Type',
        scheme: 'Scheme',
        busCls: 'Include Public Liability Business Class',
        prntCvrLttr: 'Print Cover Letter',
        premRt: 'Premium Rating',
        minPrem: 'Minimum Premium',
        pubLbltyPrem: 'Public Liability Premium',
        format: 'Export Format',
        export: 'Export to',
        printRptRunTime: 'Print Runtime Parameters'
      },
      reportForm: {
        expiryDateFrom: undefined,
        expiryDateTo: new Date(),
        acctFrm: undefined,
        acctTo: undefined,
        polType: 'All',
        scheme: 'All',
        busCls: '',
        prntCvrLttr: 'UPP',
        premRt: undefined,
        minPrem: undefined,
        pubLbltyPrem: undefined,
        format: undefined,
        printRptRunTime: true,
        isRedemption: true
      },
      // HelpList
      multiPolTypeList: false,
      multiSchemeList: false,
      multiBusClsList: false,
      // Other
      today: new Date(),
      fromDateMinDate: new Date(2000, 0, 1),
      menu: {},
      company: {},
      supportedFormat: [],
      loading: false,
      billAcctNoList: [],
      prntCvrLttrList: [
        { label: 'UPP', value: 'UPP' },
        { label: 'UPP HDB', value: 'UPPHDB' },
        { label: 'Other', value: 'Other' }],
      panel1: [0],
      panel2: [0],
      panel3: [0]
    }
  },
  computed: {
    isNotUPPHDB() {
      return !(this.reportForm.prntCvrLttr === 'UPPHDB')
    },
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.uwReports.menu !== 1) {
          await this.$store.dispatch('uwReportsInit')
        }
        this.getCommonData('company')
        this.getCommonDataList2('billAcctNoList')
        const apiURI = this.rptMenu.initRedemptionRpt
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result
          if (data) {
            this.supportedFormat = data.data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    doAssignPolType(Obj) {
      this.reportForm.polType = []
      this.reportForm.polType = Obj.finalSelectedItems.toString()
    },
    async doAssignScheme(Obj) {
      this.reportForm.scheme = []
      this.reportForm.scheme = Obj.finalSelectedItems.toString()
    },
    async doAssignBusCls(Obj) {
      this.reportForm.busCls = []
      this.reportForm.busCls = Obj.finalSelectedItems.toString()
    },
    doClose() {
      this.multiPolTypeList = false
      this.multiSchemeList = false
      this.multiBusClsList = false
    },
    doAcctNoFr() {
      if ((this.reportForm.acctFrm !== null && this.reportForm.acctFrm !== undefined && this.reportForm.acctFrm !== '') &&
      (this.reportForm.acctTo === null || this.reportForm.acctTo === undefined || this.reportForm.acctTo === '')) {
        this.reportForm.acctTo = this.reportForm.acctFrm
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport().then(result => {
            if (this.reportForm.format === 'PDF') {
              this.processExportCoverLetter()
            }
          })
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.loading = true
          await this.$http.post(apiURI, this.reportForm)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async processExportCoverLetter() {
      const apiURI = this.menu.genRenCvrLet
      if (apiURI) {
        try {
          this.loading = true
          await this.$http.post(apiURI, this.reportForm)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    fromDateMax() {
      return new Date(2070, 11, 31)
    },
    fromDateValidation(toDate1) {
      if (toDate1) {
        return 'required|checkDateRangeFrom:' + toDate1
      } else {
        return 'required|checkDateRangeFrom'
      }
    },
    toDateValidation(fromDate1) {
      if (fromDate1) {
        return 'required|checkDateRangeTo:' + fromDate1
      } else {
        return 'required|checkDateRangeTo'
      }
    },
    defaultI508(value) {
      if (value.masCo === 'I805' && this.reportForm.prntCvrLttr === 'UPPHDB') {
        this.reportForm.premRt = (0.045).toFixed(6)
        this.reportForm.minPrem = (50.00).toFixed(2)
        this.reportForm.pubLbltyPrem = (10.00).toFixed(2)
      } else {
        this.reportForm.premRt = (0.00).toFixed(6)
        this.reportForm.minPrem = (0.00).toFixed(2)
        this.reportForm.pubLbltyPrem = (0.00).toFixed(2)
      }
    },
    decFormat(val) {
      if (val === 'pubLbltyPrem') {
        let val = Number(this.reportForm.pubLbltyPrem)
        this.reportForm.pubLbltyPrem = val.toFixed(2)
      } else if (val === 'premRt') {
        let val = Number(this.reportForm.premRt)
        this.reportForm.premRt = val.toFixed(6)
      } else if (val === 'minPrem') {
        let val = Number(this.reportForm.minPrem)
        this.reportForm.minPrem = val.toFixed(2)
      }
    }
  },
  created() {
    this.doInit()
    this.$validator.extend('checkDateRangeFrom', checkDateRangeFrom)
    this.$validator.extend('checkDateRangeTo', checkDateRangeTo)
  },
  watch: {
    company: function(value) {
      this.defaultI508(this.company)
    },
    'reportForm.prntCvrLttr': function (value) {
      this.defaultI508(this.company)
    }
  },
  mixins: [
    MessageMixin,
    commonAjaxMixin
  ],
  components: {
    MultiPolTypeHelpList,
    MultiSchemeHelpList,
    MultiBusClsHelpList
  }
}
</script>
